import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
/* eslint-disable-next-line import/no-unresolved */
import backend from '@jg/i18next-dynamic-import-backend';
import LngDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next)
  .use(
    backend(
      lang =>
        import(/* webpackChunkName: "lang/[request]" */ `./locales/common.${lang}.json5`),
      { loadDefault: true },
    ),
  )
  .use(LngDetector)
  .init({
    whitelist: ['en', 'en-GB', 'en-US', 'en-AU'],
    fallbackLng: 'en',
    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'locale',
    },
  });

export default i18n;
